// @flow

import * as React from 'react';
import { withRouter } from 'react-router-dom';

type Props = {
  children?: React.Node,
  render: React.Node,
  path: string;
  isLazy?: boolean,
  location: Location,
}

/*
 * Turn this componenent into a React.PurComponent
 * make inners router having weird behavior
 */

class SliderElement extends React.Component<Props> {
  static defaultProps = {
    children: null,
    isLazy: false,
  };

  render() {
    if (this.props.isLazy && !this.props.location.pathname.startsWith(this.props.path)) {
      return null;
    }
    return (
      this.props.children ?
        this.props.children :
        this.props.render
    );
  }
}

export default withRouter(SliderElement);
